const descriptions = {
  headingTitle: {
    id: 'course-authoring.textbooks.header.title',
    defaultMessage: 'Textbooks',
    description: 'Title for the textbooks section',
  },
  breadcrumbContent: {
    id: 'course-authoring.textbooks.header.breadcrumb.content',
    defaultMessage: 'Content',
    description: 'Breadcrumb for content',
  },
  breadcrumbPagesAndResources: {
    id: 'course-authoring.textbooks.header.breadcrumb.pages-and-resources',
    defaultMessage: 'Pages & resources',
    description: 'Breadcrumb for pages and resources',
  },
  breadcrumbAriaLabel: {
    id: 'course-authoring.textbooks.header.breadcrumb.aria-label',
    defaultMessage: 'Textbook breadcrumb',
    description: 'Aria label for the textbook breadcrumb',
  },
  newTextbookButton: {
    id: 'course-authoring.textbooks.header.new-textbook',
    defaultMessage: 'New textbook',
    description: 'Text for the button to create a new textbook',
  },
};

export default descriptions;
